import React from "react";
import "./TimeStamp.scss";
import TimeStampProps from "./TimeStamp.types";

const TimeStamp = ({ hours, minutes, status,work, className }: TimeStampProps) => {
  const [isActive, setActive] = React.useState(false);

  return (
    <div
      className={`time-stamp${isActive ? " active" : ""} ${className} time-stamp--${work}`}
      aria-hidden="true"
      onClick={() => setActive(!isActive)}
    >
      {" "}
      {hours}:{minutes} {status}
    </div>
  );
};

export default TimeStamp;
